import { customization } from '@yola/ws-sdk';
import store from 'src/js/store';

const updateCustomFontPairs = (initialFontPairs, updatedFontPairs) => {
  customization.helpers
    .getCustomFontPairsToDelete(initialFontPairs, updatedFontPairs)
    .forEach((id) => store.dispatch(customization.actions.deleteCustomFontPair(id)));

  customization.helpers
    .getCustomFontPairsToCreate(initialFontPairs, updatedFontPairs)
    .forEach((fontPair) => store.dispatch(customization.actions.addCustomFontPair(fontPair)));

  customization.helpers
    .getCustomFontPairsToUpdate(initialFontPairs, updatedFontPairs)
    .forEach((fontPair) => store.dispatch(customization.actions.updateCustomFontPair(fontPair)));
};

export default updateCustomFontPairs;
